
export const GET_IS_API_LOADING = 'getIsApiLoading';

export const getters = {
    [GET_IS_API_LOADING](state) {
        return state.isApiLoading;
    }
}
